export function SET_ACCESS_TOKEN({ commit }, [access_token, refresh_token, user_firebase_token]) {
	commit('SAVE_ACCESS_TOKEN', [access_token, refresh_token, user_firebase_token])
}

export function SET_USER_TOKEN({ commit }, [access_token]) {
	commit('SAVE_USER_TOKEN', [access_token])
}

export function SET_USER_DATA(
	{ commit },
	[
		accept_terms_and_conditions,
		email,
		full_name,
		has_mandatory_surveys,
		id,
		id_user_campaign_selected,
		id_user_client_country_selected,
		id_user_client_profile,
		id_user_client_selected,
		id_user_language_selected,
		is_superuser,
		user_client_module_items,
		user_clients,
		user_firebase_document,
		user_firebase_document_ranking_areas,
		user_image,
		user_reward_campaign,
		user_branches,
		user_campaigns,
		status,
		accept_cookies_policy,
		has_mandatory_drills,
	]
) {
	commit('SAVE_USER_DATA', [
		accept_terms_and_conditions,
		email,
		full_name,
		has_mandatory_surveys,
		id,
		id_user_campaign_selected,
		id_user_client_country_selected,
		id_user_client_profile,
		id_user_client_selected,
		id_user_language_selected,
		is_superuser,
		user_client_module_items,
		user_clients,
		user_firebase_document,
		user_firebase_document_ranking_areas,
		user_image,
		user_reward_campaign,
		user_branches,
		user_campaigns,
		status,
		accept_cookies_policy,
		has_mandatory_drills,
	])
}

export function SET_TERMS_AND_CONDITIONS(context, [accept_terms_and_conditions]) {
	context.commit('SAVE_TERMS_AND_CONDITIONS', [accept_terms_and_conditions])
}

export function SET_USER_IMAGE(context, [user_image]) {
	context.commit('SAVE_USER_IMAGE', [user_image])
}

export function SET_USER_COUNTRIES(context, [user_countries]) {
	context.commit('SAVE_USER_COUNTRIES', [user_countries])
}

export function SET_RELOAD_CONTENT(context, [reload_content]) {
	context.commit('SAVE_RELOAD_CONTENT', [reload_content])
}

export function SET_CLIENT(context, [id_user_client_selected]) {
	context.commit('SAVE_CLIENT', [id_user_client_selected])
}

export function SET_COUNTRY(context, [id_user_client_country_selected]) {
	context.commit('SAVE_COUNTRY', [id_user_client_country_selected])
}

export function SET_LANGUAGE(context, [id_user_language_selected]) {
	context.commit('SAVE_LANGUAGE', [parseInt(id_user_language_selected)])
}

export function SET_LANGUAGE_CODE({ commit }, [user_language_selected]) {
	commit('SAVE_LANGUAGE_CODE', [user_language_selected])
}

export function SET_LEFT_MENU(context, [left_menu]) {
	context.commit('SAVE_LEFT_MENU', [left_menu])
}

export function SET_RIGHT_MENU(context, [right_menu]) {
	context.commit('SAVE_RIGHT_MENU', [right_menu])
}

export function SET_ADMIN_LEFT_MENU(context, [admin_left_menu]) {
	context.commit('SAVE_ADMIN_LEFT_MENU', [admin_left_menu])
}

export function SET_MANDATORY_SURVEYS(context, [has_mandatory_surveys]) {
	context.commit('SAVE_MANDATORY_SURVEYS', [has_mandatory_surveys])
}

export function SET_MANDATORY_DRILL(context, [has_mandatory_drills]) {
	context.commit('SAVE_MANDATORY_DRILL', [has_mandatory_drills])
}

export function SET_HAS_CLOSE_BANNER_DRILLS(context, [has_close_banner_drills]) {
	context.commit('SAVE_HAS_CLOSE_BANNER_DRILLS', [has_close_banner_drills])
}

export function SET_WEBSERVICE_TOKEN(context, [webservice_token]) {
	context.commit('SAVE_WEBSERVICE_TOKEN', [webservice_token])
}

export function SET_DEVICE_TOKEN(context, [device_token]) {
	context.commit('SAVE_DEVICE_TOKEN', [device_token])
}

export function SET_USER_CHANGE_PASSWORD(context, [user_change_password]) {
	context.commit('SAVE_USER_CHANGE_PASSWORD', [user_change_password])
}

export function SET_ID_USER_CAMPAIGN_SELECTED(context, [id_user_campaign_selected]) {
	context.commit('SAVE_ID_USER_CAMPAIGN_SELECTED', [id_user_campaign_selected])
}

export function SET_REDIRECT_URL(context, [redirect_url]) {
	context.commit('SAVE_REDIRECT_URL', [redirect_url])
}

export function SET_COOKIES_POLICY(context, [accept_cookies_policy]) {
	context.commit('SAVE_COOKIES_POLICY', [accept_cookies_policy])
}

export function SET_DATE_REQUEST_USER_DATA(context, [date]) {
	context.commit('SAVE_DATE_REQUEST_USER_DATA', [date])
}

export function SET_MUST_CHANGE_PASSWORD(context, must_change_password) {
	context.commit('SAVE_MUST_CHANGE_PASSWORD', must_change_password)
}

export function SET_SET_LOCALE_PROCESSED(context, set_locale_processed) {
	context.commit('SAVE_SET_LOCALE_PROCESSED', set_locale_processed)
}

export function START_PHONE_COOLDOWN({ commit }, duration) {
  commit('SAVE_VERIFICARION_PHONE_BUTTON', {
    startTime: Date.now(),
    duration: duration
  })
}

export function CHECK_COOLDOWN({ commit, state }) {
  const { startTime, duration } = state.verificacion_phone_button
  if (startTime) {
    const now = Date.now()
    const elapsed = Math.floor((now - startTime) / 1000)
    
    if (elapsed >= duration) {
      commit('RESET_VERIFICACION_PHONE')
    }
  }
}

export function SET_VERIFICACION_PHONE_BUTTON({ commit }, time) {
  commit('SAVE_VERIFICARION_PHONE_BUTTON', {
    startTime: Date.now(),
    duration: time
  })
}
